import React from 'react';

import Exit from './IntroExit';
import IntroHeader from './IntroHeader';
import { useT } from '~app/BundleProvider';
import SimpleMap from '~app/components/SVG/SimpleMap';

const Page2 = ({ direction, children }) => {
  const t = useT();
  return (
    <div className={`intro-page page-2 ${direction}`}>
      <IntroHeader />
      <Exit />
      <main role="main">
        <h1 className="intro-headline">{t("introduction")}</h1>
        <SimpleMap ariaDescription={t("page-2-image-description")} page="page-2"/>

        {children}

      </main>
    </div>
  );
};

export default Page2;



// WEBPACK FOOTER //
// ./src/pages/intro/Page2.js